import { CityDropdownForTrip, CommonInput } from 'components';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { FaCheck, FaCrown } from 'react-icons/fa6';
import { RiInformationLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { load } from '@cashfreepayments/cashfree-js';
import toast from 'react-hot-toast';

import coupon from '../../assets/img/coupon.svg';
import shield from '../../assets/img/shield.svg';
import logo from "../../assets/img/transport360Logo.svg";
import { ConfirmModalFor, PaymentBillingModal } from 'modals';
import { UserContext } from 'context';
import { StorageServices } from 'utils';
import { applyDiscountCodeApi, createOrderPayment, getCompanyDetailsApi, subscriptionListApi } from '_services';
import { FaArrowLeftLong } from "react-icons/fa6";
import './subscription.css'
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import StorageService from 'utils/StorageServices';

const GST_RATE_DIVISOR = 100;

const initialFormData = {
  company_id: StorageServices.getCompanyId(),
  order_id: '',
  total_years: 1,
  total_amount: 0,
  plan_price: 0,
  gst_price: 0,
  coupon: '',
  selected_subscription_id: '',
  customised_plan: {
    branches: 0,
    users: 0,
  },
  gst_details: {
    gst_number: '',
    company_name: '',
    email_address: '',
  },
  billing_address: {
    address: '',
    city: '',
    state: '',
    pin_code: '',
  },
  adjustmentAmount: 0
};

const SubscriptionPlan = () => {
  const navigate = useNavigate();

  const CASHFREE_MODE = process.env.REACT_APP_CASHFREE_MODE;

  const { subscriptionDetails, setSubscriptionDetails } = useContext(UserContext);

  const [formData, setFormData] = useState(initialFormData);
  const [branches, setBranches] = useState(subscriptionDetails?.no_of_branch);
  const [users, setUsers] = useState(subscriptionDetails.min_no_of_user);
  const [hasGST, setHasGST] = useState(true);
  const [isOpenBillingModal, setIsOpenBillingModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [companyDetailsLoaded, setCompanyDetailsLoaded] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);

  const isUserLimitReached = useMemo(() =>
    subscriptionDetails?.max_no_of_user === users,
    [subscriptionDetails?.max_no_of_user, users]
  );

  const [errors, setErrors] = useState({
    gst_details: {
      gst_number: "",
      company_name: "",
      email_address: "",
    },
    billing_address: {
      address: "",
      city: "",
      state: "",
      pin_code: "",
    },
  });

  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isCouponLoading, setIsCouponLoading] = useState(false);

  const formatIndianNumber = useCallback((num) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }, []);

  // ✅ Agar subscriptionDetails me adjusted_price nahi hai toh API se fetch karo
  // useEffect(() => {
  //   if (!subscriptionDetails?.adjusted_price) {
  //     getSubscriptionPlans();
  //   }
  // }, []);

  // const getSubscriptionPlans = async () => {
  //   try {
  //     const res = await subscriptionListApi({
  //       company_id: StorageServices?.getCompanyId(),
  //       device_type: 1
  //     });
  //     if (res?.responseCode === 200) {
  //       const plans = res?.data?.subscription || [];
  //       const currentPlan = res?.data?.current_plan;

  //       // ✅ subscription[] me se current_plan ko match karo
  //       const matchedPlan =
  //         plans.find(p => p._id === currentPlan?._id) ||
  //         plans.find(p => p.plan_type === currentPlan?.plan_type) ||
  //         currentPlan;

  //       // ✅ matched plan + current_plan ke runtime fields merge karo
  //       setSubscriptionDetails({
  //         ...matchedPlan,
  //         adjusted_price: currentPlan?.adjusted_price,
  //         monthly_rate: currentPlan?.monthly_rate,
  //         monthly_branch_rate: currentPlan?.monthly_branch_rate,
  //         monthly_user_rate: currentPlan?.monthly_user_rate,
  //         web_end_date: currentPlan?.web_end_date,
  //         mobile_end_date: currentPlan?.mobile_end_date,
  //         subscription_start_date: currentPlan?.subscription_start_date,
  //         is_current_plan: 1,
  //       });

  //     } else {
  //       navigate(-1);
  //     }
  //   } catch (error) {
  //     navigate(-1);
  //   }
  // };

  const getComapnyDetailsHandle = async () => {
    try {
      const res = await getCompanyDetailsApi({ company_id: StorageService.getCompanyId() });
      const companyDetails = res?.data?.company;
      const formattedData = {
        ...formData,
        company_id: StorageServices.getCompanyId(),
        gst_details: {
          gst_number: companyDetails?.gst_no || '',
          company_name: companyDetails?.company || '',
          email_address: companyDetails?.email_id || '',
        },
        billing_address: {
          address: `${companyDetails?.address_line1 || ''} ${companyDetails?.address_line2 || ''}`.trim(),
          city: companyDetails?.city?.value || '',
          state: companyDetails?.state?.value || '',
          pin_code: companyDetails?.pincode || '',
        },
      };

      setFormData(formattedData);
      setCompanyDetailsLoaded(true);
    } catch (error) {
      console.error("Error fetching company details:", error);
      setCompanyDetailsLoaded(true);
    }
  };

  const fetchFromCity = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,
    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}` }));
      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const generateOrderId = useCallback(() => {
    const now = new Date();
    const dateStr = now.getFullYear() +
      String(now.getMonth() + 1).padStart(2, '0') +
      String(now.getDate()).padStart(2, '0');
    const timeStr = String(now.getHours()).padStart(2, '0') +
      String(now.getMinutes()).padStart(2, '0') +
      String(now.getSeconds()).padStart(2, '0');
    return `order_${dateStr}_${timeStr}`;
  }, []);

  const calculateTotal = useCallback((subscriptionDetails, branches, users, gstRate, discountAmount) => {
    if (!subscriptionDetails) {
      return { plan_price: 0, gst_price: 0, total_amount: 0, adjustmentAmount: 0 };
    }

    const { actual_rate, branch_rate, user_rate, no_of_branch, min_no_of_user, adjusted_price } = subscriptionDetails;

    const additionalBranches = Math.max(0, branches - no_of_branch);
    const additionalUsers = Math.max(0, users - min_no_of_user);

    const planPrice = actual_rate + (branch_rate * additionalBranches) + (user_rate * additionalUsers);
    const afterAdjustment = Math.max(0, planPrice + (adjusted_price || 0));
    const afterDiscount = Math.max(0, afterAdjustment - discountAmount);
    const gstPrice = afterDiscount * gstRate;
    const totalAmount = afterDiscount + gstPrice;

    return {
      plan_price: Number(afterDiscount.toFixed(2)),
      gst_price: Number(gstPrice.toFixed(2)),
      total_amount: Number(totalAmount.toFixed(2)),
      adjustmentAmount: Number(afterAdjustment.toFixed(2)),
    };
  }, []);

  const validateField = (section, field, value) => {
    let error = "";
    const strValue = value?.toString() || "";

    if (section === "gst_details") {
      if (field === "company_name" && !strValue.trim()) {
        error = "Company name is required";
      }
      if (field === "email_address" && strValue.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(strValue)) {
          error = "Invalid email address";
        }
      }
      if (field === "gst_number" && hasGST) {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!strValue.trim()) {
          error = "GST number is required";
        } else if (!gstRegex.test(strValue.toUpperCase())) {
          error = "Invalid GST number";
        }
      }
    }

    if (section === "billing_address") {
      if (field === "address" && !strValue.trim()) error = "Address is required";
      if (field === "city" && !strValue.trim()) error = "City is required";
      if (field === "state" && !strValue.trim()) error = "State is required";
      if (field === "pin_code") {
        if (!strValue.trim()) {
          error = "Pin code is required";
        } else if (!/^\d{6}$/.test(strValue)) {
          error = "Invalid pin code";
        }
      }
    }

    return error;
  };

  const handleChange = (section, field, value) => {
    // ✅ billing_address fields hamesha string rahenge
    const skipNumericConversion = section === "billing_address" ||
      (section === "gst_details");

    const parsedValue =
      !skipNumericConversion &&
        typeof value === "string" &&
        !isNaN(value) &&
        value !== ""
        ? Number(value)
        : value;

    setFormData((prev) => {
      if (!section) {
        return { ...prev, [field]: parsedValue };
      }
      return {
        ...prev,
        [section]: { ...prev[section], [field]: parsedValue },
      };
    });

    const error = validateField(section, field, parsedValue);
    setErrors((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: error || "" },
    }));
  };

  const validateGstDetails = () => {
    let isValid = true;
    const newGstErrors = { gst_number: "", company_name: "", email_address: "" };
    const { gst_number, company_name, email_address } = formData.gst_details;

    if (!company_name.trim()) {
      newGstErrors.company_name = "Company name is required";
      isValid = false;
    }
    if (email_address.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email_address)) {
        newGstErrors.email_address = "Invalid email format";
        isValid = false;
      }
    }
    if (hasGST) {
      if (!gst_number.trim()) {
        newGstErrors.gst_number = "GST number is required";
        isValid = false;
      } else {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!gstRegex.test(gst_number.toUpperCase())) {
          newGstErrors.gst_number = "Invalid GST number format";
          isValid = false;
        }
      }
    }

    setErrors((prev) => ({ ...prev, gst_details: newGstErrors }));
    return isValid;
  };

  const validateBillingDetails = () => {
    let isValid = true;
    const newBillingErrors = { address: "", city: "", state: "", pin_code: "" };
    const { address, city, state, pin_code } = formData.billing_address;

    if (!address.trim()) { newBillingErrors.address = "Address is required"; isValid = false; }
    if (!city.trim()) { newBillingErrors.city = "City is required"; isValid = false; }
    if (!state.trim()) { newBillingErrors.state = "State is required"; isValid = false; }

    const pin = pin_code?.toString() || "";
    if (!pin.trim()) {
      newBillingErrors.pin_code = "Pin code is required";
      isValid = false;
    } else if (!/^\d{6}$/.test(pin)) {
      newBillingErrors.pin_code = "Invalid pin code";
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, billing_address: newBillingErrors }));
    return isValid;
  };

  const clearBillingAddress = useCallback(() => {
    setFormData((prev) => ({
      ...prev,
      billing_address: { address: '', city: '', state: '', pin_code: '' },
    }));
    setErrors((prev) => ({
      ...prev,
      billing_address: { address: "", city: "", state: "", pin_code: "" },
    }));
  }, []);

  const handleBranchChange = useCallback((increment) => {
    const newBranches = Math.max(0, branches + increment);
    setBranches(newBranches);
    handleChange('customised_plan', 'branches', newBranches);
  }, [branches, handleChange]);

  const handleUserChange = useCallback((increment) => {
    if (increment > 0 && isUserLimitReached) {
      toast.error(`You can add maximum ${subscriptionDetails?.max_no_of_user} users in this plan`);
      return;
    }
    const newUsers = Math.max(0, users + increment);
    setUsers(newUsers);
    handleChange('customised_plan', 'users', newUsers);
  }, [users, isUserLimitReached, subscriptionDetails?.max_no_of_user, handleChange]);

  const initializeCashfreePayment = useCallback(async (paymentSessionId) => {
    try {
      const cashfree = await load({ mode: CASHFREE_MODE });
      const checkoutOptions = {
        paymentSessionId,
        redirectTarget: "_self",
        appearance: {
          width: "500px",
          height: "650px",
          primaryColor: "#3B82F6",
          backgroundColor: "#FFFFFF",
          theme: {
            primaryColor: "#3B82F6",
            secondaryColor: "#F3F4F6",
            backgroundColor: "#FFFFFF",
            textColor: "#1F2937",
            borderColor: "#E5E7EB",
            errorColor: "#EF4444",
            successColor: "#10B981"
          }
        },
        modal: { closeOnOverlayClick: false, closeOnEsc: false },
        merchant: { name: "Transport 360", logo: logo }
      };
      await cashfree.checkout(checkoutOptions);
    } catch (error) {
      console.error("Cashfree SDK error:", error);
      toast.error("Payment system error. Please try again.");
    }
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);

    const getReturnUrl = () => `${window.location.origin}/dashboard`;
    const { adjustmentAmount, coupon, ...restFormData } = formData;

    const payload = {
      ...restFormData,
      selected_subscription_id: subscriptionDetails?._id,
      order_id: generateOrderId(),
      return_url: getReturnUrl(),
      company_id: StorageServices.getCompanyId(),
      coupon: discountAmount > 0 ? coupon : "",
      discount_price: discountAmount > 0 ? discountAmount : 0,
    };

    try {
      const res = await createOrderPayment(payload);
      if (res?.responseCode === 200) {
        const { payment_session_id } = res.data;
        if (!payment_session_id) {
          toast.error("Failed to create payment session");
          return;
        }
        clearBillingAddress();
        setIsOpenBillingModal(false);
        await initializeCashfreePayment(payment_session_id);
      } else {
        toast.error(res?.message || "Failed to create order. Please try again.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [formData, discountAmount, subscriptionDetails?._id, generateOrderId, clearBillingAddress, initializeCashfreePayment]);

  // ✅ subscriptionDetails ready hone ke baad company details fetch karo
  useEffect(() => {

    getComapnyDetailsHandle();

  }, [subscriptionDetails]);

  useEffect(() => {
    if (!subscriptionDetails?._id || !companyDetailsLoaded) return;

    const gstRate = (subscriptionDetails?.gst_perc || 0) / GST_RATE_DIVISOR;
    const { plan_price, gst_price, total_amount, adjustmentAmount } = calculateTotal(
      subscriptionDetails, branches, users, gstRate, discountAmount
    );

    setFormData((prev) => ({ ...prev, plan_price, gst_price, total_amount, adjustmentAmount }));
  }, [subscriptionDetails, branches, users, calculateTotal, companyDetailsLoaded, discountAmount]);

  useEffect(() => {
    if (!subscriptionDetails?._id && companyDetailsLoaded) {
      navigate("/subscription");
    }
  }, [subscriptionDetails?._id, navigate, companyDetailsLoaded]);

  const handleBillingSubmit = (e) => {
    e.preventDefault();
    if (validateBillingDetails()) handleSubmit(e);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    const isGstValid = validateGstDetails();
    const isBillingValid = validateBillingDetails();
    if (isGstValid && isBillingValid) handleSubmit(e);
  };

  const handleDiscountCode = async () => {
    setIsCouponLoading(true);
    const payload = {
      company_id: StorageServices?.getCompanyId(),
      plan_id: subscriptionDetails?._id,
      coupon_code: formData.coupon,
      total_amount: formData.adjustmentAmount,
    };
    try {
      const res = await applyDiscountCodeApi(payload);
      if (res?.responseCode == 200) {
        setIsCouponApplied(true);
        setDiscountAmount(res?.data?.amount);
      }
      setIsCouponLoading(false);
    } catch (error) {
      setIsCouponLoading(false);
    }
  };

  const payBillModalProps = useMemo(() => ({
    isOpen: isOpenBillingModal,
    closeModal: () => {
      clearBillingAddress();
      setIsOpenBillingModal(false);
    },
    modalMainClass: "_dashCommon_Modal __payBil_modal",
    setFormData,
    formData,
    handleChange,
    handleSubmit: handleBillingSubmit,
    loading,
    errors,
  }), [isOpenBillingModal, clearBillingAddress, formData, handleChange, handleSubmit, loading]);

  if (!subscriptionDetails?._id && companyDetailsLoaded) return null;

  let confirmModalProps = {
    show: showMessage,
    closeModal: () => setShowMessage(false),
    title: "Message",
    confirmModal: "confirmModal",
  };

  return (
    <>
      <button className="back-btn" onClick={() => navigate("/subscription")}>
        <FaArrowLeftLong className="back-icon" />
        Back To Plan
      </button>

      <div className='__selPlan_mainBx'>
        <div className='__selPlan_container'>

          {/* ─── LEFT COLUMN ─── */}
          <div className='__selPlan_firstBx'>
            <div className="accordion" id="planAccordion">

              {/* Selected Plan */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#selectedPlan"
                    aria-expanded="true"
                    aria-controls="selectedPlan"
                  >
                    <span className="__selPlan_checked"><FaCheck /></span>
                    <span className='__selPlan_acordHead'>Selected Plan</span>
                    <span className="__selPlan_badge">
                      <span><FaCrown /></span>
                      {subscriptionDetails.plan_name}
                    </span>
                  </button>
                </h2>
                <div id="selectedPlan" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <div className="__selPlan__details">
                      <div>
                        <h5 className="__selPlan__deHead">{subscriptionDetails.plan_name}</h5>
                        <div className='__selPlBadge_bx'>
                          <span className="__selPlan__deBadge">1 year</span>
                          <span className="__selPlan__deBadge">{`${subscriptionDetails.min_no_of_user} Users`}</span>
                          <span className="__selPlan__deBadge">{`${subscriptionDetails.no_of_branch} Branch`}</span>
                        </div>
                      </div>
                      <div className="__selPlan__deAmt text-end">
                        <h5 className="__selPlan__dePrc">
                          {`₹ ${formatIndianNumber(Number(subscriptionDetails?.actual_rate || 0))}`}
                        </h5>
                        <small className="__selPlan__deAnnl">
                          {`@ ₹${formatIndianNumber(subscriptionDetails?.actual_rate || 0)} / billed annually`}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Customise Plan */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#customisePlan"
                    aria-expanded="true"
                    aria-controls="customisePlan"
                  >
                    <span className='__selPlan_acordHead'>Customise Plan</span>
                  </button>
                </h2>
                <div id="customisePlan" className="accordion-collapse collapse show">
                  <div className="accordion-body">

                    {/* Branch */}
                    <div className="__selPlan_customBx">
                      <div className='__delPlan_numTx'>
                        <p>Number of Branch</p>
                        <small>{`₹${formatIndianNumber(subscriptionDetails?.branch_rate || 0)} / Branch`}</small>
                      </div>
                      <div className="input-group">
                        <button
                          className="btn"
                          onClick={() => handleBranchChange(-1)}
                          disabled={branches === subscriptionDetails?.no_of_branch}
                          style={{
                            backgroundColor: branches === subscriptionDetails?.no_of_branch ? '#d3d3d3' : '',
                            cursor: branches === subscriptionDetails?.no_of_branch ? 'not-allowed' : 'pointer',
                          }}
                        >−</button>
                        <input
                          type="text"
                          className="form-control text-center"
                          value={`${branches} Branch${branches !== 1 ? "es" : ""}`}
                          readOnly
                        />
                        <button className="btn" onClick={() => handleBranchChange(1)}>+</button>
                      </div>
                    </div>

                    {/* Users */}
                    <div className="__selPlan_customBx">
                      <div className='__delPlan_numTx'>
                        <p>Number of User</p>
                        <small>{`₹${formatIndianNumber(subscriptionDetails?.user_rate || 0)} / User`}</small>
                      </div>
                      <div className="input-group">
                        <button
                          className="btn"
                          onClick={() => handleUserChange(-1)}
                          disabled={users === subscriptionDetails.min_no_of_user}
                          style={{
                            backgroundColor: users === subscriptionDetails.min_no_of_user ? '#d3d3d3' : '',
                            cursor: users === subscriptionDetails.min_no_of_user ? 'not-allowed' : 'pointer',
                          }}
                        >−</button>
                        <input
                          type="text"
                          className="form-control text-center"
                          value={`${users} User${users !== 1 ? "s" : ""}`}
                          readOnly
                        />
                        <button
                          className="btn"
                          onClick={() => {
                            if (isUserLimitReached) setShowMessage(true);
                            else handleUserChange(1);
                          }}
                          style={{
                            backgroundColor: users === subscriptionDetails?.max_no_of_user ? '#d3d3d3' : '',
                            cursor: users === subscriptionDetails?.max_no_of_user ? 'not-allowed' : 'pointer',
                          }}
                        >+</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* Billing Details */}
              <div className="accordion-item __notAccordion">
                <h2 className="accordion-header">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" aria-expanded="true" aria-controls="billDetails">
                    <span className='__selPlan_acordHead'>Billing Details</span>
                  </button>
                </h2>
                <div className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <div className="__selPl_bilGst">
                      <span>I have GSTIN:</span>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={hasGST}
                          onChange={(e) => setHasGST(e.target.checked)}
                        />
                      </div>
                    </div>

                    <div className='__selInput_flx'>
                      {hasGST && (
                        <div className="__billInput_bx">
                          <CommonInput
                            placeholder="e.g., 27AABCCDDEEFFG"
                            label="Enter GST number"
                            value={formData.gst_details.gst_number}
                            onChange={(e) => handleChange('gst_details', 'gst_number', e.target.value)}
                            error={errors.gst_details.gst_number}
                          />
                        </div>
                      )}

                      <div className="__billInput_bx">
                        <CommonInput
                          placeholder="Enter company name"
                          label="Enter company name"
                          value={formData.gst_details.company_name}
                          onChange={(e) => handleChange('gst_details', 'company_name', e.target.value)}
                          error={errors.gst_details.company_name}
                        />
                      </div>

                      <div className="__billInput_bx">
                        <CommonInput
                          placeholder="contact@company.com"
                          label="Enter email address"
                          type="email"
                          value={formData.gst_details.email_address}
                          onChange={(e) => handleChange('gst_details', 'email_address', e.target.value)}
                          error={errors.gst_details.email_address}
                        />
                      </div>

                      <div className={`__billInput_bx ${hasGST ? "w-100" : ""}`}>
                        <CommonInput
                          label="Street address*"
                          placeholder="Enter street address"
                          value={formData.billing_address.address}
                          onChange={(e) => handleChange('billing_address', 'address', e.target.value)}
                          error={errors?.billing_address.address}
                        />
                      </div>

                      <div className="__billInput_bx">
                        <CityDropdownForTrip
                          key="city"
                          label="City"
                          placeholder="Select a city"
                          fetchData={fetchFromCity}
                          pageSize={20}
                          onChange={(data) => {
                            handleChange('billing_address', 'city', data.name);
                            handleChange('billing_address', 'state', data.stateName);
                          }}
                          selectedItem={{
                            label: formData.billing_address.city ? `${formData.billing_address.city}` : "",
                            name: formData.billing_address.city ? `${formData.billing_address.city}` : "",
                            _id: `${formData.billing_address.city}`,
                          }}
                          withState={false}
                          error={errors?.billing_address.city}
                          errorMessage={errors?.billing_address.city}
                        />
                      </div>

                      <div className="__billInput_bx">
                        <CommonInput
                          label="State*"
                          value={formData.billing_address.state}
                          disabled={formData.billing_address.state}
                          placeholder="Enter State"
                          error={errors?.billing_address.state}
                        />
                      </div>

                      <div className={`__billInput_bx ${hasGST ? "w-100" : ""}`}>
                        <CommonInput
                          label="Pin Code*"
                          value={formData.billing_address.pin_code}
                          onChange={(e) => handleChange('billing_address', 'pin_code', e.target.value)}
                          placeholder="e.g., 560001"
                          error={errors?.billing_address.pin_code}
                          maxLength={6}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* ─── DIVIDER ─── */}
          <div className='__selPlan_secondBx'>
            <div className='__selPl_divider'></div>
          </div>

          {/* ─── RIGHT COLUMN ─── */}
          <div className='__selPlan_thirdBx'>
            <div className="__selConfirm_planBx">
              <h5 className="__revHead mb-3">Review & Confirm Your Plan</h5>

              <div className='__flxr_seLplx'>
                <div className="__sled_pln_bxs">
                  <div className='__scr_prx'>

                    <div className="__sle_priceFlx_head">
                      <span>Plan Price (1 Year)</span>
                      <span>{`₹${formatIndianNumber(subscriptionDetails.actual_rate)}`}</span>
                    </div>

                    {branches > subscriptionDetails.no_of_branch && (
                      <div className="__sle_priceFlx">
                        <span>
                          {`${branches - subscriptionDetails.no_of_branch} Additional Branch${(branches - subscriptionDetails.no_of_branch) > 1 ? 'es' : ''}`}
                        </span>
                        <span>{`₹${formatIndianNumber(subscriptionDetails.branch_rate * (branches - subscriptionDetails.no_of_branch))}`}</span>
                      </div>
                    )}

                    {users > subscriptionDetails.min_no_of_user && (
                      <div className="__sle_priceFlx">
                        <span>
                          {`${users - subscriptionDetails.min_no_of_user} Additional User${(users - subscriptionDetails.min_no_of_user) > 1 ? 's' : ''}`}
                        </span>
                        <span>{`₹${formatIndianNumber(subscriptionDetails.user_rate * (users - subscriptionDetails.min_no_of_user))}`}</span>
                      </div>
                    )}

                    <div className="__sle_priceFlx">
                      <span>Current Plan Adjustment</span>
                      <span>{`₹${formatIndianNumber(subscriptionDetails?.adjusted_price || 0)}`}</span>
                    </div>

                    {discountAmount > 0 && (
                      <div className="__sle_priceFlx" style={{ color: '#22C55E' }}>
                        <span>Discount (Coupon Applied)</span>
                        <span>{`- ₹${formatIndianNumber(discountAmount)}`}</span>
                      </div>
                    )}
                  </div>

                  <div className="__sle_gstFlx">
                    <span className='d-flex align-items-center gap-1.5'>
                      <span className='__sel_InfoBx'><RiInformationLine /></span>
                      {`GST ${subscriptionDetails.gst_perc}% of ₹${formatIndianNumber(formData.plan_price)}`}
                    </span>
                    <p>{`₹${formatIndianNumber(formData.gst_price)}`}</p>
                  </div>

                  <div className="__sel_totalFlx">
                    <h6 className="mb-0">Amount to Pay</h6>
                    <h5 className="text-primary mb-0">
                      {`₹${formatIndianNumber(formData.total_amount)}`}
                    </h5>
                  </div>
                </div>

                {/* Coupon */}
                <div className="__refralBx">
                  <label className="form-label __revHead">
                    Apply Referral code or Discount code
                  </label>
                  <div className="input-group">
                    <div className="__inputRef">
                      <img src={coupon} alt="coupon" />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter code"
                        value={formData.coupon}
                        onChange={(e) => handleChange("", "coupon", e.target.value.toUpperCase())}
                      />
                      {formData.coupon && (
                        <span
                          className="__clearInput"
                          onClick={() => {
                            setDiscountAmount(0);
                            setIsCouponApplied(false);
                            handleChange("", "coupon", "");
                          }}
                        >✕</span>
                      )}
                    </div>
                    <button
                      className="__refApply_btn"
                      onClick={handleDiscountCode}
                      disabled={isCouponApplied || !formData.coupon}
                      style={{
                        cursor: isCouponApplied ? "not-allowed" : "pointer",
                        opacity: isCouponApplied ? 0.7 : 1,
                      }}
                    >
                      {isCouponLoading ? "Applying.." : isCouponApplied ? "Applied ✓" : "Apply"}
                    </button>
                  </div>
                </div>

                {/* Pay Button */}
                <div className='__selPay_btn'>
                  <button
                    className="anime-btn __payShield_btn"
                    onClick={handleSubmitAll}
                    disabled={loading}
                  >
                    <img src={shield} alt="shield" />
                    {loading ? "Processing..." : `Pay Securely ₹${formatIndianNumber(formData.total_amount)}`}
                  </button>
                  <p>{`Exclusive of all taxes (${subscriptionDetails.gst_perc}% GST)`}</p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      {isOpenBillingModal && (
        <PaymentBillingModal {...payBillModalProps} />
      )}

      {showMessage && (
        <ConfirmModalFor {...confirmModalProps}>
          <p className="_confirmPrx">
            Your current plan has reached the maximum user limit. Please upgrade your plan to add more users.
          </p>
        </ConfirmModalFor>
      )}
    </>
  );
};

export default SubscriptionPlan;